import { CSSProperties } from 'react'

const STAGGER_DELAY_MS = 50
const MAX_STAGGER_ITEMS = 20

interface StaggeredEntranceOptions {
  delayMs?: number
  maxItems?: number
}

export function getStaggerStyle(index: number, options?: StaggeredEntranceOptions): CSSProperties {
  const delay = options?.delayMs ?? STAGGER_DELAY_MS
  const max = options?.maxItems ?? MAX_STAGGER_ITEMS
  const clampedIndex = Math.min(index, max)
  return {
    animationDelay: `${clampedIndex * delay}ms`,
  }
}
